/* tslint:disable */
/* eslint-disable */
/**
 * Example API
 * API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Account
 */
export interface Account {
    /**
     * Unique identifier for the account
     * @type {string}
     * @memberof Account
     */
    readonly id: string;
    /**
     * Unique subject identifier for the account
     * @type {string}
     * @memberof Account
     */
    subjectId: string;
    /**
     * Email address associated with the account
     * @type {string}
     * @memberof Account
     */
    email: string;
    /**
     * Username associated with the account
     * @type {string}
     * @memberof Account
     */
    userName: string;
    /**
     * Timestamp when the account was created
     * @type {Date}
     * @memberof Account
     */
    readonly createdAt: Date;
    /**
     * Timestamp when the account was last updated
     * @type {Date}
     * @memberof Account
     */
    readonly updatedAt: Date;
    /**
     * Number of credits available for the account
     * @type {number}
     * @memberof Account
     */
    credits: number;
    /**
     * IDs of orders associated with this account
     * @type {Array<string>}
     * @memberof Account
     */
    readonly orderIds: Array<string>;
    /**
     * Number of orders associated with this account
     * @type {number}
     * @memberof Account
     */
    ordersCount: number;
    /**
     * About me section for the account
     * @type {string}
     * @memberof Account
     */
    aboutMe: string;
    /**
     * URL of the account avatar
     * @type {string}
     * @memberof Account
     */
    avatarUrl: string;
}

/**
 * Check if a given object implements the Account interface.
 */
export function instanceOfAccount(value: object): value is Account {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('subjectId' in value) || value['subjectId'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('userName' in value) || value['userName'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('credits' in value) || value['credits'] === undefined) return false;
    if (!('orderIds' in value) || value['orderIds'] === undefined) return false;
    if (!('ordersCount' in value) || value['ordersCount'] === undefined) return false;
    if (!('aboutMe' in value) || value['aboutMe'] === undefined) return false;
    if (!('avatarUrl' in value) || value['avatarUrl'] === undefined) return false;
    return true;
}

export function AccountFromJSON(json: any): Account {
    return AccountFromJSONTyped(json, false);
}

export function AccountFromJSONTyped(json: any, ignoreDiscriminator: boolean): Account {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'subjectId': json['subjectId'],
        'email': json['email'],
        'userName': json['userName'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'credits': json['credits'],
        'orderIds': json['orderIds'],
        'ordersCount': json['ordersCount'],
        'aboutMe': json['aboutMe'],
        'avatarUrl': json['avatarUrl'],
    };
}

  export function AccountToJSON(json: any): Account {
      return AccountToJSONTyped(json, false);
  }

  export function AccountToJSONTyped(value?: Omit<Account, 'id'|'createdAt'|'updatedAt'|'orderIds'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'subjectId': value['subjectId'],
        'email': value['email'],
        'userName': value['userName'],
        'credits': value['credits'],
        'ordersCount': value['ordersCount'],
        'aboutMe': value['aboutMe'],
        'avatarUrl': value['avatarUrl'],
    };
}

